<div class="all-wrap">
  <mat-toolbar *ngIf="!isLoginRoute && isLoggedIn && (selectedAdvId || perms.isAdmin)" class="main-header">
    <button (click)="toggle()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
    <div class="branding">
      <div class="logo"></div>
    </div>
    <p class="ml-1" *ngIf="environment !== 'prod'">{{ environment }}</p>
    <div fxFlex></div>

    <!-- Impersonation banner -->
    <div id="impersonated-advertiser" *ngIf="perms.isAdmin && perms.isImpersonating && selectedAdvName && !isAdminRoute">
      {{ selectedAdvName }}
    </div>

    <!-- Advertiser picker (non-admin with multiple advertisers) -->
    <div *ngIf="!perms.isAdmin && user.advertisers && user.advertisers.length > 1" class="global-dropdown">
      <mat-form-field [floatLabel]="'never'" class="global-select">
        <mat-select placeholder="Advertiser" [(ngModel)]="selectedAdvId" (selectionChange)="selectAdvertiser()">
          <mat-option *ngFor="let adv of advertisers" [value]="adv.id">{{ adv.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Single advertiser label -->
    <div *ngIf="!perms.isAdmin && user.advertisers && user.advertisers.length === 1">
      {{ user.advertisers[0].name }}
    </div>

    <!-- Brand picker (visible for non-admin OR when admin is impersonating) -->
    <div class="global-dropdown" *ngIf="!perms.isAdmin || perms.isImpersonating">
      <mat-form-field [floatLabel]="'never'" class="global-select">
        <mat-select placeholder="Brand" class="brand-select" [(ngModel)]="selectedBrandId" (selectionChange)="selectBrand($event)">
          <mat-option value="">Select Brand</mat-option>
          <mat-optgroup label="Active Brands">
            <mat-option *ngFor="let brand of enabledBrands" [value]="brand.id">
              {{ brand.name }} > {{ brand['profileName']}}
            </mat-option>
          </mat-optgroup>
          <mat-optgroup label="Inactive Brands" *ngIf="perms.isAdmin">
            <mat-option *ngFor="let brand of disabledBrands" [value]="brand.id" [disabled]="true">
              {{ brand.name }} > {{ brand['profileName']}}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-toolbar>

  <mat-toolbar *ngIf="isLoginRoute || !isLoggedIn" class="main-header">
    <div class="branding">
      <div class="logo"></div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="app-inner" [class.login-active]="isLoginRoute">
    <!--    Where the Real Nav Begins-->
    <mat-sidenav
        *ngIf="isLoggedIn && (selectedAdvId || perms.isAdmin)"
        #sidemenu
        class="sidebar-panel mat-elevation-z4"
        id="sidebar-panel"
        [mode]="isOver() ? 'over' : 'side'"
        [opened]="!isOver()"
    >
      <mat-nav-list class="navigation">

        <!-- Home -->
        <mat-list-item
          routerLink="/manage/home-page"
          [ngClass]="{'selected': setActiveNav('/manage/home-page')}"
        >
          <a class="relative" matRipple>
            <span>Home</span>
          </a>
        </mat-list-item>

        <!-- Data (Ad Codes) -->
        <mat-list-item
          *ngIf="canAccessAdCodes()"
          routerLink="/manage/ad-codes"
          [ngClass]="{'selected': setActiveNav('/manage/ad-codes')}"
          [disabled]="!canAccessAdCodes()"
        >
          <a class="relative" matRipple>
            <span>Data</span>
          </a>
        </mat-list-item>

        <!-- Looker Dashboard Menu Items -->
        <ng-container *ngFor="let grouping of lookerSidenavGroupings | keyvalue">
          <mat-accordion>
            <mat-expansion-panel class="mat-elevation-z0" *ngIf="canAccessLookerItem(grouping.key)">
              <mat-expansion-panel-header class="accordion-padding">
                <mat-panel-title class="exceptions-sidenav-item">{{ grouping.key }}</mat-panel-title>
              </mat-expansion-panel-header>

              <ng-container *ngIf="grouping.key === 'Dashboards'">
                <app-looker-list-item [meta]="{friendly_name: 'Detection Reports', client_route: 'detailed-detections'}"></app-looker-list-item>
              </ng-container>

              <ng-container *ngFor="let meta of grouping.value">
                <ng-container *ngIf="meta.client_route !== 'detailed-detections'">
                  <app-looker-list-item [meta]="meta"></app-looker-list-item>
                </ng-container>
              </ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>

        <!-- Change Management -->
        <mat-list-item
          routerLink="/manage/change-management"
          [ngClass]="{'selected': setActiveNav('/manage/change-management')}"
          *ngIf="canAccessChangeManagementItem()"
          [disabled]="!canAccessChangeManagementItem()"
        >
          <a class="relative" matRipple>
            <span>Change Management</span>
          </a>
        </mat-list-item>

        <!-- Settings Menu -->
        <mat-list-item
          (click)="toggleSettings($event)"
          *ngIf="canAccessMenuItem() && canAccessAuthItem() && !perms.isAdvManager"
        >
          <a class="relative" matRipple>
            <span>Settings</span>
            <span fxFlex></span>
            <i class="menu-caret" [ngClass]="settingsExpanded ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </a>
        </mat-list-item>

        <mat-nav-list class="sub-menu" *ngIf="settingsExpanded">
          <mat-list-item
            *ngIf="canAccessMenuItem() && canAccessAuthItem()"
            routerLink="/manage/advertiser-settings"
            [ngClass]="{'selected': setActiveNav('/manage/advertiser-settings')}"
          >
            <a class="relative" matRipple>
              <span>Advertiser Settings</span>
            </a>
          </mat-list-item>

          <mat-list-item
            *ngIf="isAgency && canAccessMenuItem() && canAccessAuthItem()"
            routerLink="/manage/agency-settings"
            [ngClass]="{'selected': setActiveNav('/manage/agency-settings')}"
          >
            <a class="relative" matRipple>
              <span>Agency Settings</span>
            </a>
          </mat-list-item>
        </mat-nav-list>

        <!-- Account Information -->
        <mat-list-item
          [disabled]="!canAccessMenuItem()"
          *ngIf="isAdminOrAdvManager()"
          (click)="toggleAccountSettings($event)"
        >
          <a class="relative" matRipple>
            <span>Account Information</span>
            <span fxFlex></span>
            <i class="menu-caret" [ngClass]="accountSettingsExpanded ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </a>
        </mat-list-item>

        <mat-nav-list class="sub-menu" *ngIf="accountSettingsExpanded && canAccessAdvManagerItem()">
          <mat-list-item *ngIf="!perms.isAdvManager" routerLink="/manage/team-members"
                         [ngClass]="{'selected': setActiveNav('/manage/team-members')}">
            <a class="relative" matRipple>
              <span>Team Members</span>
            </a>
          </mat-list-item>
          <mat-list-item *ngIf="selectedBrandId !== ''" routerLink="/manage/brand-settings"
                         [ngClass]="{'selected': setActiveNav('/manage/brand-settings')}">
            <a class="relative" matRipple>
              <span>Brand Settings</span>
            </a>
          </mat-list-item>
          <mat-list-item *ngIf="isBilled" routerLink="/manage/paymentInformation"
                         [ngClass]="{'selected': setActiveNav('/manage/paymentInformation')}">
            <a class="relative" matRipple>
              <span>Payment Information</span>
            </a>
          </mat-list-item>
        </mat-nav-list>

        <span class="dividing-line" *ngIf="perms.isAdmin"></span>
        <!-- Admin menu -->

        <mat-list-item
          *ngIf="perms.canAccessEncoder(brandDao.getCurrentBrand())"
          routerLink="/manage/onboarding"
          [ngClass]="{'selected': setActiveNav('/manage/onboarding')}"
          (click)="goToBvsEncode()"
        >
          <a class="relative" matRipple>
            <span>Portal Encoder</span>
          </a>
        </mat-list-item>

        <mat-list-item *ngIf="perms.isAdmin" routerLink="/manage/admin"
                       [ngClass]="{'selected': setActiveNav('/manage/admin')}">
          <a class="relative" matRipple>
            <span>Admin</span>
          </a>
        </mat-list-item>

        <mat-list-item *ngIf="perms.isAdmin" routerLink="/manage/admin/engineering"
                       [ngClass]="{'selected': setActiveNav('/manage/admin/engineering')}">
          <a class="relative" matRipple>
            <span>Engineering</span>
          </a>
        </mat-list-item>

        <mat-list-item>
          <a class="relative" matRipple routerLink="/manage/user-profile" [ngClass]="{'selected': setActiveNav('/manage/user-profile')}" (click)="goToProfile()">
            <span>User Settings</span>
          </a>
        </mat-list-item>

        <mat-list-item *ngIf="false">
          <a matRipple href="https://docs.google.com/forms/d/e/1FAIpQLSfOrn2PxvlVHpjRKVPk1TmLJ-liFq9Mb5R9jmtjRwfMSb7MmQ/viewform?usp=sf_link" target="_blank">
            <span>Get Help</span>
          </a>
        </mat-list-item>

        <mat-list-item (click)="logout()">
          <a class="relative" matRipple>
            <span>Logout</span>
          </a>
        </mat-list-item>

      </mat-nav-list>
    </mat-sidenav>
    <router-outlet></router-outlet>
  </mat-sidenav-container>

  <footer #footer id="footer" *ngIf="!isLoginRoute">
    <div class="app-footer-container">
      <nav class="app-footer-nav" fxLayout="row" fxLayoutGap="24px" fxLayoutGap.xs="16px" fxLayout.xs="column">
        <a href="https://kinetiq.tv/" target="_blank">Home</a>
        <a href="https://kinetiq.tv/tv-detection-attribution/" target="_blank">Solutions</a>
        <a href="https://kinetiq.tv/resources/" target="_blank">Resources</a>
        <a href="https://kinetiq.tv/company/" target="_blank">Company</a>
        <a href="https://live-kinetiqtv.pantheonsite.io/careers/" target="_blank">Careers</a>
      </nav>

      <hr class="app-footer-divider" />

      <div
        class="app-footer-bottom"
        fxLayout="row"
        fxLayoutAlign="space-between start"
        fxLayout.xs="column"
        fxLayoutAlign.xs="center center"
        fxLayoutGap.xs="12px"
      >
        <div class="app-footer-legal" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">
          <a href="https://kinetiq.tv/privacy-policy/" target="_blank">Privacy Policy</a>
          <a href="https://kinetiq.tv/copyright-abuse/" target="_blank">Copyright Abuse</a>
          <a href="https://kinetiq.tv/security-policy/" target="_blank">Security Policy</a>
          <span class="app-footer-copyright">&copy; {{ currentYear }} Kinetiq. All rights reserved.</span>
        </div>
        <div class="app-footer-social" fxLayout="row" fxLayoutGap="8px">
          <a
            href="https://www.linkedin.com/company/kinetiq-tv"
            target="_blank"
            class="app-footer-icon"
            aria-label="Kinetiq on LinkedIn"
          >
            <i class="fab fa-linkedin"></i>
          </a>
          <a href="https://kinetiq.tv/contact/" target="_blank" class="app-footer-icon" aria-label="Contact Kinetiq">
            <i class="fa fa-envelope"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</div>
